module.exports = __webpack_public_path__ + "img/settings.aede3b4b.svg";